import type { ImmutableArray, ValidatorType } from "shelving";
import { AllowStringSchema } from "shelving";

/** Property that defines the privacy of an object. */
export const PRIVACY = new AllowStringSchema({
	title: "Privacy",
	allow: {
		private: "Only you",
		approved: "Followers",
		public: "Public",
	},
});
export type PrivacyType = ValidatorType<typeof PRIVACY>;
export type PrivacyTypes = ImmutableArray<PrivacyType>;

export const PUBLIC_PRIVACIES: ImmutableArray<PrivacyType> = ["public"];
export const APPROVED_PRIVACIES: ImmutableArray<PrivacyType> = ["public", "approved"];
export const PRIVATE_PRIVACIES: ImmutableArray<PrivacyType> = ["public", "approved", "private"];
